import { Modal, ModalBody,} from 'reactstrap';
import { RiLogoutBoxRLine } from "react-icons/ri";

function LogoutModal({ isConfirmationModalOpen, setIsConfirmationModalOpen }) {

  const toggle = () => setIsConfirmationModalOpen(!isConfirmationModalOpen);

  return (
    <div>
      <Modal isOpen={isConfirmationModalOpen} toggle={toggle} centered>
        <ModalBody style={{ display: "grid", gap: '1rem', placeItems: 'center', padding: '2rem' }}>
          <RiLogoutBoxRLine size={120} color='#fda425' />

          <div style={{ fontWeight: 500 }} >Are you sure you Want to Log Out?</div>

          <div>
            <button className='btn' style={{ backgroundColor: '#fabc42', paddingInline: '3rem', color: 'white' }} onClick={toggle}>No</button>
            <button className='btn' style={{ backgroundColor: '#f5f5f5', paddingInline: '3rem' }}>Yes</button>
          </div>

        </ModalBody>
      </Modal>
    </div>
  );
}

export default LogoutModal;